<script setup>
import ProductListingSystemToggle from '@/app/components/product-listing/product-listing-system-toggle.vue';
import { inject, computed } from 'vue';
const config = inject('config');

import { useProductsStore } from '@/app/stores/productsStore.js';

const productsStore = useProductsStore();

const mobileActionText = computed(() =>
  productsStore.hideFilterMobile ? config.showFilter : config.hideFilter,
);

function handleMobileAction() {
  productsStore.hideFilterMobile = !productsStore.hideFilterMobile;
}
</script>

<template>
  <div class="c-product-listing-filter__toggle">
    <div class="c-product-listing-filter__mobile-action">
      <button class="c-product-listing-filter__mobile-action-btn" @click="handleMobileAction">
        {{ mobileActionText }}
      </button>
    </div>
    <ProductListingSystemToggle />
  </div>
</template>